import { connect } from 'react-redux';

import {
    CampaignBrandLiftCell,
    CampaignBrandLiftCellProps
} from '../../components/CampaignBrandLiftCell/CampaignBrandLiftCell';
import { selectClientId } from '../../selectors/common';
import { BrandSurveyStatus } from '../../typings/campaigns';
import { GdCampaignPrimaryStatus } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

export interface CampaignBrandLiftCellContainerOwnProps {
    brandSurveyId: string;
    brandSurveyStatus: BrandSurveyStatus;
    status: GdCampaignPrimaryStatus;
}

export type CampaignBrandLiftCellContainerStateProps = TStateProps<
    CampaignBrandLiftCellProps,
    CampaignBrandLiftCellContainerOwnProps
>;

export type CampaignBrandLiftCellContainerDispatchProps = {};

const mapStateToProps = (
    state: State
): CampaignBrandLiftCellContainerStateProps => {
    const clientId = selectClientId(state);

    return {
        clientId
    };
};

const mapDispatchToProps = () => ({});

const mergeProps = (
    stateProps: CampaignBrandLiftCellContainerStateProps,
    dispatchProps: CampaignBrandLiftCellContainerDispatchProps,
    ownProps: CampaignBrandLiftCellContainerOwnProps
): CampaignBrandLiftCellProps => {
    return {
        ...stateProps,
        ...ownProps
    };
};

export const CampaignBrandLiftCellContainer = connect<
    CampaignBrandLiftCellContainerStateProps,
    CampaignBrandLiftCellContainerDispatchProps,
    CampaignBrandLiftCellContainerOwnProps,
    CampaignBrandLiftCellProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CampaignBrandLiftCell);
